import React from 'react'
import { Button } from '../../../../ui/Button'
import { Spinner } from '../../../../ui/Spinner'
import { UserInfoCard } from './UserInfoCard'
import { ProcessStepsCard } from './ProcessStepsCard'
import { InfoAlert } from './InfoAlert'
import type { UserInfo, AppointmentConfig } from '../types'
import ContinueLaterModal from '../../../../../components/onboarding/ContinueLaterModal'

interface ScheduleVisitFormProps {
  userInfo: UserInfo
  isLoading: boolean
  config: AppointmentConfig
  onScheduleWithCalendly: () => void
  onContinueWithoutAppointment: () => void
}

export const ScheduleVisitForm: React.FC<ScheduleVisitFormProps> = ({
  userInfo,
  isLoading,
  config,
  onScheduleWithCalendly,
}) => {
  console.log('userinfo', userInfo)
  return (
    <div className="max-w-3xl mx-auto">
      {/* Header */}
      <div className="text-center mb-2">
        <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb">
          <span className="text-xl">{config.icon}</span>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          {config.title}
        </h1>
        <p className="text-gray-600 mb-2">{config.subtitle}</p>
        <p className="text-sm text-gray-500">{config.description}</p>
      </div>
      <div className="my-4">
        <InfoAlert
          title={config.infoAlert.title}
          description={config.infoAlert.description}
          variant={config.infoAlert.variant}
        />
      </div>

      {/* User Information */}
      <UserInfoCard userInfo={userInfo} />

      {/* Process Steps */}
      <ProcessStepsCard steps={config.processSteps} />

      {/* Action buttons */}
      <div className="flex flex-col justify-center sm:flex-row gap-3 sm:gap-4 pt-2">
        <ContinueLaterModal />
        <Button
          onClick={onScheduleWithCalendly}
          disabled={isLoading}
          size="default"
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="mr-2" />
              Preparando Calendly...
            </>
          ) : (
            <>
              {/* <span className="mr-2">{config.icon}</span> */}
              {config.buttons.primary}
            </>
          )}
        </Button>
      </div>
    </div>
  )
}
